<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <consent-letter-data-table
              v-if="nmInterface"
              ref="jtDataTable"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ConsentLetterDataTable from './ConsentLetterDataTable'
const { pageTable } = JtCrud

@Component({
  mixins: [pageTable],
  name: 'ConsentLetterPageTable',
  components: { ConsentLetterDataTable }
})
class ConsentLetterPageTable extends Vue {
}
export default ConsentLetterPageTable
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
